module.exports = __webpack_public_path__ + "static/media/selfie_ubicar_celular.42d81415.svg";